import React from 'react';
import AutoSuggestInput from './AutoSuggestInput';

export default class AutoSuggestMultiInput extends React.Component {

    onRemoveSelection(selection) {
        this.props.update(this.props.name, this.props.selection.filter(s => s[this.props.suggestionKey] !== selection[this.props.suggestionKey]));
    }

    render() {
        return (
            <div>
                <AutoSuggestInput multi={true} {...this.props} />
                {this.props.selection.map(selectionItem =>
                    <div key={selectionItem[this.props.suggestionKey]} className="chip name-chip">
                        <span>{selectionItem[this.props.suggestionValue]}</span>
                        <i className="material-icons delete-chip" onClick={this.onRemoveSelection.bind(this, selectionItem)}>close</i>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/AutoSuggestMultiInput.jsx